<template>
   <v-container fluid pa-3 background  class="contain_width">

    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="SearchData"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top:7px;color:#fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>
     <filter-component :json_data ="form_dialog_data" v-on:set="onCloseFormDialog" />

    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>

     <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter">
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="SearchData"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="SearchData"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12 v-if="permission_edit == true || admin == 'true'">
        <v-tooltip top>
          <v-btn
            slot="activator"
            color="primary"
            dark
            fixed
            bottom
            right
            fab
            @click="onHandleDialog(true, 'create', null)"
          >
            <v-icon>fa-plus</v-icon>
          </v-btn>
          <span>{{$t('create')}}</span>
        </v-tooltip>
      </v-flex>
      <v-layout
        row
        align-center
        text-xs-center
        style="margin-top:5rem;margin-bottom:15rem"
         v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer">
          <v-tooltip top>
            <template slot="activator">
              <div
                @click="onHandleDialog(true, 'create', null)"
                style="padding-top:40px;padding-bottom:40px;"
              >
                <v-icon style="font-size:80px;" color="blue">fa fa-plus</v-icon>
                <h3 class="headline mb-0" style="color:#2195F3;">{{$t('AddOtPlan')}}</h3>
              </div>
            </template>
            <span>{{$t('ClickFor')}} {{$t('AddOtPlan')}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex lg6 md6 sm12 xs12 pa-1 v-for="(item, index) in table_data" :key="index" @click="''">
            <v-card class="coco-box-shadow ">
              <v-layout row wrap class="coco-list-layout" pa-3>
                <v-flex lg1 md1 sm2 xs2 style="margin:auto">
                  <v-avatar :size="64">
                         <v-avatar
                      v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                      :size="64"
                      color="teal"
                    >
                      <span class="white--text headline">{{item.nick_name}}</span>
                    </v-avatar>

                    <Empimage
                      v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                      :json_data="item.emp_images"
                    />
                  </v-avatar>
                </v-flex>
                <v-flex lg7 md7 sm7 xs8>
                  <v-layout row wrap>
                    <v-flex xs4>
                      <span
                        class="coco-list-label-text"
                      >{{isEmpty(item.emp_code)? item.emp_code : 'emp_code'}}:</span>
                      
                    </v-flex>
                    <v-flex xs6>
                      <b v-show="item.ot_type == 0" style="color: #EF6C00;">ชั่วโมง</b>
                      <b v-show="item.ot_type == 1" style="color: #D500F9;">เต็มวัน</b>
                    </v-flex>
                    <v-flex xs12>
                     
                      <span>{{item.firstName}} {{item.lastName}}</span>
                      <span
                        v-html="' (<span style=color:#166BFF;>'+(isEmpty(item.nick_name) ? item.nick_name : 'nick_name')+'</span>)'"
                      />
                    </v-flex>
                    
                    <v-flex xs12 class="hidden-xs-only">
                      <span class="coco-list-label-text hidden-sm-only">
                          {{$t('branch')}}:
                        <span>
                          {{isEmpty(item.branch)? item.branch
                          : 'branch'}}
                        </span>
                      </span>
                    </v-flex>
                    <v-flex xs12 class="hidden-xs-only">
                      <span class="coco-list-label-text hidden-sm-only">
                        {{$t('Department')}}:
                        <span>
                          {{isEmpty(item.department_name) ?
                          item.department_name : 'department_name'}}
                        </span>
                      </span>
                    </v-flex>

                    <v-flex xs12 class="hidden-xs-only">
                      <span class="coco-list-label-text hidden-sm-only">
                        {{$t('Position')}}:
                        <span>
                          {{isEmpty(item.position) ?
                          item.position : 'position'}}
                        </span>
                      </span>
                   </v-flex>
                   <v-flex xs12 class="hidden-xs-only">
                     
                      <span class="coco-list-label-icon">
                        <v-icon>assignment</v-icon>
                        <span>{{isEmpty(item.doc_no) ? item.doc_no : "doc_no"}}</span>
                      </span>
                      <span class="coco-list-label-icon">
                        <v-icon>access_time</v-icon>
                        <span>
                          {{formatDate(item.begin_datetime, formatDates)}} -
                          {{formatTime(item.end_datetime.toString().split(' ')[1], formatDates)}}
                        </span>
                      </span>
                      <span
                        class="coco-list-label-text"
                        v-show="isEmpty(item.break_hour) && item.break_hour != 0"
                      >
                        {{$t('Breaktime')}}:
                        <span>
                          {{item.break_hour
                          + ' ' + $t('hour')}}
                        </span>
                      </span>
                      <span class="coco-list-label-text">
                        OT:
                        <span>
                          {{isEmpty(item.ot_hour)? item.ot_hour + ' ' +
                          $t('hour') : 'ot_hour'}}
                        </span>
                      </span>
                    </v-flex>

                    <v-flex xs12 class="hidden-sm-and-up">
                      <span class="coco-list-label-icon">
                        <v-icon style="padding-left: 0px;">assignment</v-icon>
                        <span>{{isEmpty(item.doc_no) ? item.doc_no : "doc_no"}}</span>
                      </span>
                      <span class="coco-list-label-icon">
                        <v-icon>access_time</v-icon>
                        <span>
                          {{formatDate(item.begin_datetime, formatDates)}} -
                          {{formatTime(item.end_datetime.toString().split(' ')[1], formatDates)}}
                        </span>
                      </span>
                    </v-flex>
                    <v-flex xs12 class="hidden-sm-and-up">
                      <span
                        class="coco-list-label-text"
                        v-show="isEmpty(item.break_hour) && item.break_hour != 0"
                      >
                        พัก:
                        <span>
                          {{item.break_hour
                          + ' ' + $t('hour')}}
                        </span>
                      </span>
                      <span class="coco-list-label-text">
                        OT:
                        <span>
                          {{isEmpty(item.ot_hour)? item.ot_hour + ' ' +
                          $t('hour') : 'ot_hour'}}
                        </span>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
             <v-flex lg2 md1 sm1 xs2>
                  <v-layout row wrap >

                    <v-flex lg2 md2 sm2 xs2 text-xs-right style="margin:auto;" >
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-menu offset-y>
                              <template  slot="activator" >
                                <v-btn icon style="color:rgba(0,0,0,0.54)">
                                  <v-icon >fas fa-ellipsis-v</v-icon>
                                </v-btn> 
                              </template>
                              <v-card class="pa-0" max-width="250">
                                  <v-card-title class="setbox" v-if="permission_edit == true || admin == 'true'"> 
                                    <v-btn color="orange" slot="activator" flat @click="onHandleDialog(true,'update',item)">
                                       <v-icon>edit</v-icon>
                                      <span>  {{$t('edit')}}</span>
                                    </v-btn>
                                  </v-card-title>
                                  <v-card-title  class="setbox" v-if="permission_edit == true || admin == 'true'">
                                      <v-btn color="red" flat @click="deleteItem(item)">
                                        <v-icon>delete</v-icon>
                                        <span>  {{$t('delete')}}</span>
                                      </v-btn>
                                  </v-card-title>
                              </v-card>
                          </v-menu>
                       </v-card-actions>
                      </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <v-dialog v-model="delDialogStatus" persistent max-width="300">
          <v-card>
            <v-toolbar dark color="blue d-1">
              <v-toolbar-title>
                <v-icon :size="20" class="px-2">fa-question-circle</v-icon>
                <span>{{$t('info.confirm_delete')}}</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              ต้องการลบข้อมูลเอกสาร OT
              <br>
              พนักงาน :{{delDialog.emp_code}} ใช่หรือไม่?
            </v-card-text>
            <v-card-actions>
              <v-layout row wrap>
                <v-flex xs6 pa-1>
                  <v-btn
                    color="error"
                    outline
                    block
                    @click="delDialogStatus = false"
                  >{{$t('cancel')}}</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="success" outline block @click="onDelete()">{{$t('submit')}}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <!-- FrmDialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="dialog_data" v-on:close-dialog="onCloseDialog"/>
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* jshint ignore:start */
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import Empimage from "../../components/getempimage.vue";
import Utils from "@/utils/";
import FrmDialog from "./FormDialog";
import FilterComponent from "./Filter";
import UserService from "@/services/UserService";


export default {
  data: () => ({
    dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
      show_search: false,
      SearchData: "",
       totalPages:0,
        form_dialog_data: {
      status: false,
       },
    table_data: [],
    pageActive: 1,
    processing: false,
    canLoadMore: true,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      name: "",
      emp_code: "",
      date: ""
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
        admin:false,
    permission_edit:false,
    permission_view:false,
    empCode: localStorage._empcode,
    permission:[],
  }),
  created: async function() {

 this.admin = localStorage._is_admin;
    await  UserService.getpermissionByusercode(this.empCode)
    .then(res=>{
      this.permission = res.data.permission;
      console.log(res)
    })
     .catch(err => {});
    await this.checkpermission("OTPlanList")

    this.setShowFilter({
      status: 0
    });
    this.commitSetToolbar({
      patternTool: "1"
    });

    this.getOTPlanList();
    // this.$store.watch(
    //   state => {
    //     state.filter.SelectBranch;
    //     state.filter.SelectDepartment;
    //     state.filter.SelectPosition;
    //     state.filter.SearchData;
    //     state.filter.FromDate;
    //     state.filter.ToDate;
    //   },
    //   () => {
    //     this.pageActive = 1;
    //     this.table_data = [];
    //     this.canLoadMore = true;
    //     this.getOTPlanList();
    //   },
    //   {
    //     deep: true
    //   }
    // );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    Empimage,
    FrmDialog,
    FilterComponent
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "FromDate",
      "ToDate"
    ]),
    ...mapState("app", ["showLoading", "formatDates"]),
    ...mapState("filter", ["Employee_List"]),
    ...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),

     checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    onCloseDialog() {
      this.pageActive = 1;
      this.table_data = [];
      this.dialog_data.status = false;
      this.getOTPlanList();
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
    },
     searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        v.getOTPlanList();
      }, 1500);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    formatTime(newTime) {
      return Utils.formatTime(newTime);
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          this.getOTPlanList();
        }
      }
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    onCloseFormDialog(value) {
      this.form_dialog_data.status = false;
      this.onload = true;
      this.getOTPlanList();
    },
    getOTPlanList() {
      this.commitSetShowLoading(true);
      DocumentService.getOTPlanList(
        this.SelectBranch,
        this.SelectDepartment,
        this.SelectPosition,
        this.SearchData,
        this.pageActive,
        this.FromDate,
        this.ToDate
      )
        .then(res => {
          if (this.table_data.length > 0) {
            if (res.data.content.length > 0) {
                this.table_data= [];
              res.data.content.forEach(data => {
                this.table_data.push(data);
              });
               this.totalPages = res.data.totalPages;
            } else {
              this.canLoadMore = false;
            }
          } else {
            this.table_data = res.data.content;
          }
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.name;
      this.delDialog.emp_code = data.firstName + " " + data.lastName;
      this.delDialog.date = "";
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteOtplan(this.delDialog.roworder)
        .then(res => {
          this.showSnackBar("delete success", "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getOTPlanList();
          this.delDialogStatus = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    },
    showFilter(status){
      this.form_dialog_data = {
        status: status,
        data:1
      };
    },
    
  }
};
</script>
<style>
.setbox{
padding: 0px !important;
text-align: left;
width: 100px;
}
 .v-card__text{
    padding:0px !important;
  }
</style>
